import { render } from "./NautilusRowElement.vue?vue&type=template&id=528806e1&scoped=true"
import script from "./NautilusRowElement.vue?vue&type=script&lang=js"
export * from "./NautilusRowElement.vue?vue&type=script&lang=js"

import "./NautilusRowElement.vue?vue&type=style&index=0&id=528806e1&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528806e1"]])

export default __exports__